export const GYCLandingPageData = {
  banner: {
    title: 'Find A Car',
    subtitle: 'Get a great deal with the help of the experts.',
    ctaLabel: 'Choose a car',
    ctaUrl: 'https://marketplace.autoexpress.co.uk/buy-a-car',
    imageUrlMobile: 'https://images.autoexpress.co.uk/autoexpress/2024/11/Range%20Rover%20v%20Volvo-18_780x488_eztxvo.jpg',
    imageUrlDesktop: 'https://images.autoexpress.co.uk/autoexpress/2024/11/Range%20Rover%20v%20Volvo-18_qxz3il.jpg',
  },
};
